import { BIKE_BONUS_PREMIUM } from '@vivaldis/web-ui'
import {
  COLD_WEATHER_BONUS_PREMIUM,
  DIMONA_PREMIUM,
  ECO_CHEQUE_PREMIUM,
  KILOMETER_COMPENSATION_PREMIUM,
  LATE_SHIFT_BONUS_PREMIUM,
  MEAL_VOUCHERS_PREMIUM,
  MOBILITY_PREMIUM,
  MORNING_SHIFT_BONUS_PREMIUM,
  NIGHT_SHIFT_BONUS_PREMIUM,
  OTHER_PREMIUM,
  SOCIAL_KILOMETER_COMPENSATION_PREMIUM
} from '../../../../../../../../Premiums'
import { PremiumUnitsEnum } from '../../../../../../../typings/PremiumUnitsEnum'

export const getDefaultUnitTypeForPremium = (premiumName: string) => {
  switch (premiumName) {
    case COLD_WEATHER_BONUS_PREMIUM:
      return PremiumUnitsEnum.PERCENT
    case LATE_SHIFT_BONUS_PREMIUM:
      return PremiumUnitsEnum.PERCENT
    case NIGHT_SHIFT_BONUS_PREMIUM:
      return PremiumUnitsEnum.PERCENT
    case MORNING_SHIFT_BONUS_PREMIUM:
      return PremiumUnitsEnum.PERCENT
    case MEAL_VOUCHERS_PREMIUM:
      return PremiumUnitsEnum.PER_DAY
    case BIKE_BONUS_PREMIUM:
      return PremiumUnitsEnum.PER_DAY
    case KILOMETER_COMPENSATION_PREMIUM:
      return PremiumUnitsEnum.PERCENT
    case SOCIAL_KILOMETER_COMPENSATION_PREMIUM:
      return PremiumUnitsEnum.PER_KILOMETER
    case ECO_CHEQUE_PREMIUM:
      return PremiumUnitsEnum.PERCENT
    case DIMONA_PREMIUM:
      return PremiumUnitsEnum.PERCENT
    case MOBILITY_PREMIUM:
      return PremiumUnitsEnum.PER_KILOMETER
    case OTHER_PREMIUM:
      return PremiumUnitsEnum.PERCENT
    default:
      return PremiumUnitsEnum.PERCENT
  }
}
